import styled from "styled-components";

export const NEXT = "NEXT";
export const PREV = "PREV";

export const DotsContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;
    width: 100%;
`;
 
export const Dot = styled.span`
    height: 10px;
    width: 10px;
    margin: 0 5px;
    background-color: ${(props) => (props.$active ? '#000' : '#ccc')};
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
`;

export const CarouselContainerWithArrow = styled.div`
  display: flex;
  transition: ${props => (props.$sliding ? "none" : "transform 2s ease")};
  transform: ${props => {
        if (!props.$sliding) return "translateX(0%)";
        if (props.dir === PREV) return "translateX(calc(2 * (-1%)))";
        if (props.dir === NEXT) return "translateX(calc(2 * (1%)))";
        return "translateX(0%)";
    }};
`;
export const CarouselContainer = styled.div`
  display: flex;
  transition: ${props => (props.$sliding ? "none" : "transform 2s ease")};
  transform: ${props => {
        if (!props.$sliding) return "translateX(-12%)";
        if (props.dir === PREV) return "translateX(calc(2 * (-12%)))";
        return "translateX(0%)";
    }};
`;


export const CarouselSlot = styled.div`
  flex-basis: 80%;
  order: ${props => props.order};
`;

export const SlideButton = styled.button`
  color: #000;
  background-color: #ffffff;
  position:${props => props.position || 'unset'};
  font-family: Open Sans;
  font-size: 20px;
  font-weight: 100;
  border-radius:50%;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid rgb(239, 239, 239);
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  float: ${props => props.$float};
  left: ${props => props.$left}px;
  right: ${props => props.$right}px;
  padding: 0px;
  height: ${props => props.height || 40}px;
  width: ${props => props.width || 40}px;
  z-index:101;
  &:focus {
    outline: 0;
  }
  `;

